import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEventinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 2h1a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h1V1a1 1 0 1 1 2 0v1h8V1a1 1 0 0 1 2 0v1zM2 4v2h12V4H2z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
export default SvgEventinline;
